/* KOTAI mega menu
 */
(() => {
  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  const OPEN_DELAY = 120;
  const CLOSE_DELAY = 220;

  const setOpen = (details, open) => {
    if (details.open === open) return;
    details.open = open; // fires 'toggle', so Dawn's HeaderMenu logic still runs
    const summary = details.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', String(open));
  };

  // Start downloading every image of a panel as soon as the pointer reaches its menu item,
  // so switching between items is instant.
  const warmImages = (details) => {
    if (details.dataset.kmmWarm) return;
    details.dataset.kmmWarm = 'true';
    details.querySelectorAll('img[loading="lazy"]').forEach((img) => {
      img.loading = 'eager';
    });
  };

  const initHover = (li) => {
    if (li.dataset.kmmBound) return;
    li.dataset.kmmBound = 'true';
    const details = li.querySelector('details.mega-menu');
    if (!details) return;
    let timer;

    li.addEventListener('pointerenter', () => {
      warmImages(details);
      if (!canHover.matches) return;
      clearTimeout(timer);
      timer = setTimeout(() => {
        document.querySelectorAll('.kmm details.mega-menu[open]').forEach((d) => {
          if (d !== details) setOpen(d, false);
        });
        setOpen(details, true);
      }, OPEN_DELAY);
    });

    li.addEventListener('focusin', () => warmImages(details));

    li.addEventListener('pointerleave', () => {
      if (!canHover.matches) return;
      clearTimeout(timer);
      timer = setTimeout(() => setOpen(details, false), CLOSE_DELAY);
    });

    // Mouse click on an already hover-opened menu keeps it open. Keyboard (detail === 0) keeps Dawn behaviour.
    const summary = details.querySelector('summary');
    summary?.addEventListener('click', (event) => {
      if (!canHover.matches || event.detail === 0) return;
      if (details.open) {
        event.preventDefault();
        clearTimeout(timer);
      }
    });
  };

  const initPreview = (content) => {
    if (content.dataset.kmmBound) return;
    content.dataset.kmmBound = 'true';
    const preview = content.querySelector('[data-kmm-preview]');
    if (!preview) return;
    const slides = [...preview.querySelectorAll('[data-kmm-slide]')];
    if (!slides.length) return;

    const fallback = preview.querySelector('[data-kmm-slide="default"]') || slides[0];
    const activate = (slide) => slides.forEach((s) => s.classList.toggle('is-active', s === slide));
    activate(fallback);

    content.querySelectorAll('[data-kmm-target]').forEach((el) => {
      const slide = preview.querySelector(`[data-kmm-slide="${CSS.escape(el.dataset.kmmTarget)}"]`);
      if (!slide) return;
      const show = () => activate(slide);
      el.addEventListener('pointerenter', show);
      el.addEventListener('focus', show);
    });

    // Back to the default image each time the panel closes
    content.closest('details')?.addEventListener('toggle', (event) => {
      if (!event.target.open) activate(fallback);
    });
  };

  const init = () => {
    document.querySelectorAll('.kmm .kmm__top').forEach(initHover);
    document.querySelectorAll('.kmm .kmm__content').forEach(initPreview);
  };

  init();
  document.addEventListener('shopify:section:load', init); // theme editor re-renders
})();
